export const isExactlyNaN = (val: any): boolean => {
	return typeof val === 'number' && isNaN(val)
}
